import "../styles/coursemap.css";

export const MobileBlock = () => {
  return (
    <div className="h-full w-full text-center z-40">
      <p
        className="font-black absolute top-1/2 left-1/2 text-2xl"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        Sorry! This application is not yet available on mobile. Please use a
        desktop or laptop computer to access the ECE Iris site.{" "}
      </p>
      {/* <div className='h-full w-full skeleton-loader'>
        </div> */}
    </div>
  );
};
